module.exports = __webpack_public_path__ + "static/media/SmartphoneQrCode.247db62c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/SmartphoneQrCode.svg
// module id = 405
// module chunks = 0